import { createFileRoute } from '@tanstack/react-router'

import { FormularioDeEntrada } from '@/components/gestor/FormularioDeEntrada'

/*
 * `/gestor`: a tela de entrada. Só chega aqui quem não tem sessão; quem tem é
 * levado para o painel pela guarda da rota-mãe.
 */
function Entrada() {
  return (
    <div className="flex flex-1 flex-col bg-page p-4 sm:p-(--gef-gestor-conteudo-recuo)">
      <FormularioDeEntrada />
    </div>
  )
}

export const Route = createFileRoute('/gestor/')({ component: Entrada })
